import React, { useState } from "react";
import { uploadRequisitionFiles } from '../../../services/clinicPortalServices/orderSearchService';

const UploadFileModel = ({ isOpen, onClose, requisitionNo, setRequisitionPdfPaths,orderdetails }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");

  const handleFileChange = (e) => {
    setSelectedFiles(e.target.files);
  };

  const handleUpload = async () => {
    if (!selectedFiles.length) {
      alert("Please select files to upload.");
      return;
    }

    const formData = new FormData();
    for (let file of selectedFiles) {
      formData.append("files", file);      
    }
    formData.append("requisitionPdfPath", requisitionNo);
    const filesArray = Array.from(selectedFiles);
    const fileNames = filesArray.map(file => file.name);
formData.append("fileNames", JSON.stringify(fileNames));

    try {      
       
      var result = await uploadRequisitionFiles(formData,requisitionNo);
      
      if (result && result.requisition_pdf_paths && Array.isArray(result.requisition_pdf_paths)) {        
        setRequisitionPdfPaths(result.requisition_pdf_paths);
        setSuccessMessage("✅ Files uploaded successfully!");
        setTimeout(() => {
          setSuccessMessage("");
          onClose(); // close modal after delay
        }, 2000);

    }
      
    } catch (error) {
      console.error("Error uploading files:", error);
      alert("Error uploading files. Check console for details.");
    }
  };
 

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
      <div className="bg-white rounded-xl shadow-lg w-96 p-6">       

        <input type="file" multiple onChange={handleFileChange} className="mb-4" />        
        {successMessage && (
          <div className="text-green-600 text-center font-medium mb-2">
            {successMessage}
          </div>
        )}
        
        <div className="flex gap-2 mb-4">
          <button
            onClick={handleUpload}
            className="btn btn-info mx-1 mb-2"
          >
            Upload
          </button>          
        </div>
 
         
      </div>
    </div>
  );
};

export default UploadFileModel;
